import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxMobileMoney from '../util/remote/ajaxMobileMoney';

const initialState = { 
    mobileKPIs: {
      successRate: 0,
      pending: 0,
      collected: 0,
    },
    KPIsLoaded: false,
    transactions: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const MobileMoneyContext = createContext();

export const MobileMoneyProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [filters, setFilters] = useState({ q: '', status: '', from: '', to: '' });

  useEffect(()=>{
      if(state.mounted){
        getMobileMoneyTransactions(false, true);
      }
    }, [state.currentPage, state.mounted])

  const getMobileKPIs = async (refresh = false) => {
    if(!refresh && state.KPIsLoaded) return;
    if(refresh){
        dispatch({ type: 'mobileKPIs', payload: initialState.mobileKPIs });
        dispatch({ type: 'KPIsLoaded', payload: false });
    }
    const server_response  = await ajaxMobileMoney.fetchKPIs({filters});
    if(server_response.status === "OK"){
        dispatch({ type: 'mobileKPIs', payload: server_response.details });
        dispatch({ type: 'KPIsLoaded', payload: true });
    }
  };

  const getMobileMoneyTransactions = async (refresh = false, nextPage = false) => {
    if(!refresh && Array.isArray(state.transactions) && !nextPage) return;
    if(refresh){
        setCurrentPage(1);
        dispatch({ type: 'transactions', payload: null });
        dispatch({ type: 'metaData', payload: null });
    }
    const server_response  = await ajaxMobileMoney.fetchTransactions({ page: refresh ? 1 : state.currentPage, filters });
    if(server_response.status === "OK"){
        dispatch({ type: 'transactions', payload: server_response.details.data });
        dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
        dispatch({ type: 'transactions', payload: '404' });
        dispatch({ type: 'metaData', payload: null });
    }
  };

   const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setMounted = (value) => {
    dispatch({ type: 'mounted', payload: value });
  };


  return(
    <MobileMoneyContext.Provider value={{
      ...state,
      filters,
      setFilters,
      dispatch,
      getMobileKPIs,
      getMobileMoneyTransactions,
      setCurrentPage ,
      setMounted
      }}>
      {children}
    </MobileMoneyContext.Provider>
  )

}

export const useMobileMoney = ()=>useContext(MobileMoneyContext);

